import { z } from 'zod';
import LangEnum from '../../../../lang/LangEnum';
import { ListOrdersV2Output } from '../../../order-book/types/orderBook.types';
import { TranslateType } from '../../../translation/translationContext.types';
import { CopyModeOnItemsConflictEnum } from './enums/CopyModeOnItemsConflict.enum';

export const buildCopyOrderProductsToExistingOrderSchema = (translate: TranslateType) =>
  z.object({
    orders: z.array(z.custom<ListOrdersV2Output>()).min(1, translate(LangEnum.GLOBAL_REQUIRED)),
    copyModeOnItemsConflict: z.enum(
      CopyModeOnItemsConflictEnum,
      translate(LangEnum.GLOBAL_REQUIRED),
    ),
    removeFromOrigin: z.boolean(),
  });
